module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_9016.40d4f343.png";